import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useMutation } from '@apollo/react-hooks';
import {
  CreateJobsArticleGroupAiImagesCreateJobMutation,
  CreateJobsArticleGroupAiImagesCreateJobMutationVariables
} from './__generated__/CreateJobsArticleGroupAiImagesCreateJobMutation';

export const CREATE_ARTICLE_GROUP_AI_IMAGES_JOB_MUTATION = gql`
  mutation CreateJobsArticleGroupAiImagesCreateJobMutation($articleGroupId: ID!, $styleType: AiImageStyleTypeEnum) {
    createJobsArticleGroupAiImagesCreateJob(articleGroupId: $articleGroupId, styleType: $styleType) {
      jobsArticleGroupAiImagesCreateJob {
        id
        status
      }
      errors
    }
  }
`;

export const useCreateJobsArticleGroupAiImagesCreateJobMutation = () => {
  return useMutation<
    CreateJobsArticleGroupAiImagesCreateJobMutation,
    CreateJobsArticleGroupAiImagesCreateJobMutationVariables
  >(CREATE_ARTICLE_GROUP_AI_IMAGES_JOB_MUTATION, { client: kmsClient });
};
